type ConnectedPlatformLike = {
  display_name?: string | null
  name?: string | null
  credentials?: {
    country?: string | null
    country_code?: string | null
    country_iso?: string | null
  } | null
  platform_info?: {
    display_name?: string | null
    name?: string | null
    logo_ref?: string | null
  } | null
} | null | undefined

const trimValue = (value?: string | null) => String(value ?? '').trim()

export const getConnectedPlatformLabel = (platform: ConnectedPlatformLike): string =>
  trimValue(platform?.display_name) ||
  trimValue(platform?.platform_info?.display_name) ||
  trimValue(platform?.name) ||
  'Channel'

export const getConnectedPlatformTypeLabel = (platform: ConnectedPlatformLike): string =>
  trimValue(platform?.platform_info?.display_name) || trimValue(platform?.platform_info?.name)

export const getConnectedPlatformMonogram = (platform: ConnectedPlatformLike): string => {
  const source = getConnectedPlatformTypeLabel(platform) || getConnectedPlatformLabel(platform)
  return source.charAt(0).toUpperCase() || 'C'
}

export const getConnectedPlatformCountryCode = (platform: ConnectedPlatformLike): string => {
  const raw =
    trimValue(platform?.credentials?.country_code) ||
    trimValue(platform?.credentials?.country_iso) ||
    trimValue(platform?.credentials?.country)

  if (!raw) return ''
  if (raw.length === 2 || raw.length === 3) return raw.toLowerCase()

  const match = raw.match(/\b([A-Za-z]{2})\b/)
  return match ? match[1].toLowerCase() : ''
}

export const getConnectedPlatformTooltip = (platform: ConnectedPlatformLike): string => {
  const label = getConnectedPlatformLabel(platform)
  const typeLabel = getConnectedPlatformTypeLabel(platform)
  const country = getConnectedPlatformCountryCode(platform)
  const parts = [label]

  if (typeLabel && typeLabel.toLowerCase() !== label.toLowerCase()) parts.push(typeLabel)
  if (country) parts.push(country.toUpperCase())

  return parts.join(' ┬╖ ')
}
